<template>
  <div>
    <div class="attribute">
      <e-tabs
        v-if="paneListPro.length"
        :active="0"
        :pane-list="paneListPro"
        @handleTabClick="handlePurchaseTabClick"
      ></e-tabs>
      <div v-else class="catalogue">产品目录</div>
      <div class="config">
        <eui-btn :disabled="classifyLoading" @click="focusClassify">维护核心产品类目</eui-btn>
      </div>
    </div>
    <div class="product">
      <el-carousel class="content-carousel" height="234px" :autoplay="defaultProps.autoplay">
        <template v-if="dataList.length">
          <div v-for="(arr, index) in dataList">
            <el-carousel-item>
              <div class="flex" style="margin-right: -20px">
                <div v-for="(list, index1) in arr" :key="index1" class="product-item">
                  <div class="product-info">
                    <div class="product-info-img">
                      <img :src="list.defaultimage" alt="" />
                    </div>
                    <p class="product-info-title">
                      {{ list.skuname }}
                    </p>
                  </div>
                  <div v-if="index1 < 4" class="line"><div></div></div>
                </div>
              </div>
            </el-carousel-item>
          </div>
        </template>
        <template v-else>
          <div v-for="item in [5, 5]" :key="item">
            <el-carousel-item>
              <div class="flex">
                <div v-for="iten in item" :key="iten" class="product-item">
                  <img :src="img" alt="" height="160" />
                </div>
              </div>
            </el-carousel-item>
          </div>
        </template>
      </el-carousel>
      <div class="config">
        <eui-btn @click="addProducts">维护核心产品</eui-btn>
      </div>
    </div>

    <AddProduct v-if="visible" :visible.sync="visible" :pane-list="paneListPro" @onSetting="onSetting"></AddProduct>

    <classifyTree
      v-if="classifyVisible"
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    ></classifyTree>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/product/index';
import AddProduct from './addProduct.vue';

import ETabs from './e-tabs.vue';
import classifyTree from './classifyTree.vue';

export default {
  components: { AddProduct, classifyTree, ETabs },
  props: {
    paneList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      classifyVisible: false,
      defaultCheckedKeys: [],
      categoryTreeData: [],

      visible: false,
      defaultProps: {
        autoplay: false,
      },

      img: require('@/assets/img/product/store-product.png'),
      classifyLoading: false,

      paneListPro: [],
    };
  },
  computed: {
    dataList() {
      const [item = {}] = this.paneList;
      const { tableData = [] } = item;

      const result = [];
      for (let i = 0; i < tableData.length; i += 5) {
        result.push(tableData.slice(i, i + 5));
      }
      console.log(result, 'result');
      return result;
    },
  },
  watch: {
    paneList: {
      handler(newVal) {
        this.paneListPro = JSON.parse(JSON.stringify(newVal));
        console.log('newVal:', newVal);
        this.defaultCheckedKeys = newVal.map((item) => item.categoryId);
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    onSetting(val) {
      this.paneListPro = [...val];
      this.$emit('onSetting', val);
    },
    handlePurchaseTabClick(val) {
      console.log('handlePurchaseTabClick', val);
    },
    addProducts() {
      if (this.paneListPro.length === 0) {
        this.$message.warning('请您先维护核心产品类目');
        return;
      }
      this.visible = true;
    },
    // 获取分类树数据
    async getAllCategoryTree() {
      try {
        this.classifyLoading = false;
        const res = await Api.companyCategoryTree();
        if (res.code === '200') {
          this.categoryTreeData = res.data;
        }
      } finally {
        this.classifyLoading = false;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      this.classifyVisible = true;
    },

    treeToArray(source) {
      const res = [];
      source.forEach((item) => {
        res.push(item);
        item.children && res.push(...this.treeToArray(item.children));
      });
      return res.map((item) => {
        if (item.children) {
          delete item.children;
        }
        return item;
      });
    },

    mergeAndRemoveDuplicates(targetArray, sourceArray, idProp = 'id') {
      return targetArray
        .filter((targetItem) => !sourceArray.some((sourceItem) => sourceItem[idProp] === targetItem[idProp]))
        .concat(sourceArray);
    },

    // 所属分类确定
    classifySubmitPopupData(val) {
      try {
        if (val.length === 0) {
          this.$emit('onSetting', val);
          this.classifyVisible = false;
          return;
        }

        if (val.length >= 10) {
          val.length = 10;
        }
        const categoryList = val.map((item) => ({
          ...item,
          label: item.categoryName,
          name: item.categoryCode,
        }));
        // 以重新选择的 类目为主 把之前相同类目的 商品再放到 新选择的类目下
        categoryList.forEach((item) => {
          this.paneList.forEach((item2) => {
            if (item.categoryId === item2.categoryId) {
              item.tableData = item2.tableData;
            }
          });
        });
        this.paneListPro = [...categoryList];
        console.log(this.paneListPro, 'this.paneListPro');
        this.defaultCheckedKeys = val.map((item) => item.categoryId);
        this.$emit('getCategoryList', categoryList);
        this.$emit('onSetting', this.paneListPro);
        this.classifyVisible = false;
      } catch (err) {
        console.log(err);
      }
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.attribute {
  height: 54px;
  position: relative;
  &:hover {
    .config {
      display: flex;
    }
  }
  .catalogue {
    height: 54px;
    line-height: 54px;
  }
  .config {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: none;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
  }
}
.product {
  position: relative;
  &:hover {
    .config {
      display: flex;
    }
  }
  .config {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: none;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .product-item {
    display: flex;
    min-width: 170px;
    height: 234px;
    background: #fff;
    /* margin-right: 10px; */
    position: relative;
    img {
      width: calc(100% - 10px);
      height: 100%;
    }
    &:last-child {
      margin-right: 0;
    }
    .line {
      width: 10px;
      height: 100%;
      flex: none;
      display: flex;
      justify-content: center;
      div {
        height: 100%;
        width: 1px;
        background: #e5e5e5;
      }
    }
    .product-info {
      width: calc(100% - 20px);
      width: 160px;
      height: 234px;
      border: 1px solid #e5e5e5;
      .product-info-img {
        height: 160px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .product-info-title {
        padding: 0 10px;
        margin-top: 16px;
        line-height: 24px;
        height: 48px;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .product_item:last-child {
    margin-right: 0;
  }
  .content-carousel {
    /* width: 880px;
    margin: 0 auto; */
    ::v-deep.el-carousel__indicators {
      display: none;
    }
    ::v-deep.el-carousel__container {
      .el-carousel__arrow {
        border-radius: 0 18px 18px 0;
      }
      .el-carousel__arrow--left {
        left: 0;
        width: 24px;
        height: 48px;
        border-radius: 0 24px 24px 0;
        line-height: 48px;
      }
      .el-carousel__arrow--right {
        right: 0;
        width: 24px;
        height: 48px;
        border-radius: 24px 0 0 24px;
        line-height: 48px;
      }
    }
  }
}
</style>
